
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bRuwj", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplatesUnifiedRelayPageQuery", function () { return $5e5e51e99cbadac3$export$a7bd550e56f5a21b; });
$parcel$export(module.exports, "getConfluenceTemplatesUnifiedRelayPageQueryVars", function () { return $5e5e51e99cbadac3$export$3f75a9344b1789fe; });
$parcel$export(module.exports, "ConfluenceTemplatesUnifiedRelayPageTemplate", function () { return $5e5e51e99cbadac3$export$378bb9d0f4f4e808; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hOqV7 = parcelRequire("hOqV7");

var $g9kzu = parcelRequire("g9kzu");

var $dyZbY = parcelRequire("dyZbY");

var $dJrvA = parcelRequire("dJrvA");

var $ahzsL = parcelRequire("ahzsL");

var $5VuC0 = parcelRequire("5VuC0");

var $4ktyF = parcelRequire("4ktyF");

var $3FBn4 = parcelRequire("3FBn4");

var $lGc56 = parcelRequire("lGc56");

var $6iG4y = parcelRequire("6iG4y");

var $lrVTP = parcelRequire("lrVTP");

var $i9Mbw = parcelRequire("i9Mbw");

var $9dL7E = parcelRequire("9dL7E");

var $4Rq88 = parcelRequire("4Rq88");

var $luoAK = parcelRequire("luoAK");

var $a8pnN = parcelRequire("a8pnN");

var $6Gqxf = parcelRequire("6Gqxf");

var $jFAtB = parcelRequire("jFAtB");

var $3elnn = parcelRequire("3elnn");

var $hPIpb = parcelRequire("hPIpb");

var $kTpnZ = parcelRequire("kTpnZ");
var $5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery;
const $5e5e51e99cbadac3$var$parseSearchTerm = (params)=>{
    const search = new URLSearchParams(params);
    return search.get("term");
};
const $5e5e51e99cbadac3$var$slugOrder = (0, $i9Mbw.AdditionalSlugs).reduce((acc, slug, index)=>{
    acc[slug] = index;
    return acc;
}, {});
const $5e5e51e99cbadac3$var$useAdditionalCategories = (categories)=>{
    const templateCategories = (0, $iSvIT.useMemo)(()=>{
        return categories.edges.map(({ node: { context: context } })=>context).filter((category)=>(0, $i9Mbw.AdditionalSlugs).includes(category.urlSlug)).sort((a, b)=>($5e5e51e99cbadac3$var$slugOrder[a.urlSlug] ?? 0) - ($5e5e51e99cbadac3$var$slugOrder[b.urlSlug] ?? 0));
    }, [
        categories
    ]);
    return templateCategories;
};
const $5e5e51e99cbadac3$var$useSortedCategories = (categories)=>{
    const adjustedCategories = (0, $iSvIT.useMemo)(()=>{
        return categories.edges.map(({ node: { context: context } })=>({
                ...context,
                ...(0, $dJrvA.getIcons)(context.urlSlug)
            })).filter((category)=>(0, $i9Mbw.DisplayedSlugs).includes(category.urlSlug)).sort((a, b)=>{
            const indexA = (0, $i9Mbw.CategoryOrder)[a.urlSlug] ?? Number.MAX_VALUE;
            const indexB = (0, $i9Mbw.CategoryOrder)[b.urlSlug] ?? Number.MAX_VALUE;
            return indexA - indexB;
        });
    }, [
        categories
    ]);
    return adjustedCategories;
};

const $5e5e51e99cbadac3$export$a7bd550e56f5a21b = $5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery !== void 0 ? $5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery : ($5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery = (parcelRequire("hbLol")), $5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery.hash && $5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery.hash !== "8cdd9c804945fbd78aa3c9fb81ac86b1" && console.error("The definition of 'confluenceTemplatesUnifiedRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $5e5e51e99cbadac3$var$_confluenceTemplatesUnifiedRelayPageQuery);
const $5e5e51e99cbadac3$export$3f75a9344b1789fe = (location, partialVars)=>{
    const isSearch = partialVars?.isSearch ?? $5e5e51e99cbadac3$var$parseSearchTerm(location.search) !== null;
    const locale = partialVars?.locale ?? (0, $a8pnN.parseQueryLocale)(location);
    return {
        locale: locale,
        partnerTemplatesDataUrlSlugs: partialVars?.partnerTemplatesDataUrlSlugs ?? (0, $6iG4y.partnerTemplatesDataUrlSlugs),
        searchQuery: partialVars?.searchQuery ?? isSearch ? {} : (0, $4Rq88.parseSearchQuery)(location, {
            withLocales: [
                locale
            ]
        }),
        isSearch: isSearch
    };
};
const $5e5e51e99cbadac3$var$getRoute = (locale, searchTerm)=>{
    let prefix = locale === "en" ? "" : `/${locale}`;
    prefix = `${prefix}/software/confluence/templates`;
    if (typeof searchTerm === "string") return `${prefix}/search?term=${searchTerm}`;
    else if (searchTerm?.type === "template" && searchTerm.name) return `${prefix}/search?term=${searchTerm.name}`;
    else if (searchTerm?.type === "category" && searchTerm.id && searchTerm.id !== (0, $luoAK.DEFAULT_CATEGORY_SLUG)) return `${prefix}/categories/${searchTerm.id}`;
    else return `${prefix}`;
};
const $5e5e51e99cbadac3$export$378bb9d0f4f4e808 = ({ queryRef: queryRef })=>{
    const location = (0, $lrVTP.useLocation)();
    const locale = (0, $3FBn4.useLocale)();
    const categorySlug = (0, $luoAK.useCategorySlug)();
    const { categories: categories, collections: collections, partnerTemplates: partnerTemplates, preloadedSearchResults: preloadedSearchResults } = (0, $hOqV7.usePreloadedQuery)($5e5e51e99cbadac3$export$a7bd550e56f5a21b, queryRef);
    const categoryName = (0, $iSvIT.useMemo)(()=>{
        if (!categorySlug || categorySlug === (0, $luoAK.DEFAULT_CATEGORY_SLUG)) return null;
        const category = categories.edges.find(({ node: { context: context } })=>context.urlSlug === categorySlug);
        return category?.node.context.name ?? null;
    }, [
        categories,
        categorySlug
    ]);
    const [searchTerm, setSearchTerm] = (0, $iSvIT.useState)(()=>{
        let term = $5e5e51e99cbadac3$var$parseSearchTerm(location.search);
        if (!term) {
            term = (0, $luoAK.parseCategorySlug)(location.pathname);
            if (term && term !== (0, $luoAK.DEFAULT_CATEGORY_SLUG)) return {
                type: "category",
                id: term
            };
            else return null;
        }
        return term;
    });
    const [searchIntent, setSearchIntent] = (0, $iSvIT.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleCategoryChange = (0, $iSvIT.useCallback)((id)=>{
        const searchTerm = {
            type: "category",
            id: id
        };
        setSearchTerm(searchTerm.id === (0, $luoAK.DEFAULT_CATEGORY_SLUG) ? null : searchTerm);
        const url = $5e5e51e99cbadac3$var$getRoute(locale, searchTerm);
        history.replaceState(null, "", url);
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "page",
            attributes: {
                category: id,
                page_path: url,
                originProduct: `wac-software-confluence-templates-categories-${id}`,
                isMarketingEvent: true
            }
        }).fire();
        (0, $5VuC0.ConfluenceTemplateAnalytics).viewTemplatesTaxonomyCategory(id);
    }, [
        createAnalyticsEvent,
        locale
    ]);
    const handleCategoryChangeIntent = (0, $iSvIT.useCallback)((id)=>{
        setSearchIntent({
            type: "category",
            id: id
        });
    }, []);
    const handleSearchSubmit = (0, $iSvIT.useCallback)((searchTerm)=>{
        setSearchTerm(searchTerm);
        history.replaceState(null, "", $5e5e51e99cbadac3$var$getRoute(locale, searchTerm));
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "confluence-templates-relay-page",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
            name: "confluence-templates-relay",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.SharedHeaderFooterContainer), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                    id: "content",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4ktyF.default), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3elnn.TemplateHeroSection), {
                                categoryName: categoryName,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jFAtB.TemplateFuzzySearch), {
                                    onSubmit: handleSearchSubmit,
                                    value: typeof searchTerm === "string" ? searchTerm : null
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $ahzsL.TemplateSectionWrapper), {
                                columnOrientation: true,
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9dL7E.TemplateCategories), {
                                        categories: $5e5e51e99cbadac3$var$useSortedCategories(categories),
                                        onCategoryChange: handleCategoryChange,
                                        onCategoryChangeIntent: handleCategoryChangeIntent
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kTpnZ.TemplateSearchResultsSection), {
                                        preloadedSearchResults: preloadedSearchResults,
                                        searchTerm: searchTerm,
                                        searchIntent: searchIntent
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Gqxf.SectionDivider), {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Gqxf.TemplateCarouselSection), {
                                collections: collections
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hPIpb.TemplateLearnFromLeadersSection), {
                                templates: partnerTemplates,
                                categories: $5e5e51e99cbadac3$var$useAdditionalCategories(categories)
                            })
                        ]
                    })
                })
            })
        })
    });
};

});
parcelRegister("9dL7E", function(module, exports) {

$parcel$export(module.exports, "TemplateCategories", function () { return $64c9d07c3c0e0c95$export$121dc1a9b075ffc; });
/* template-categories-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $cutM5 = parcelRequire("cutM5");

var $lvNuI = parcelRequire("lvNuI");

var $3FBn4 = parcelRequire("3FBn4");

var $1MbAx = parcelRequire("1MbAx");

var $lrVTP = parcelRequire("lrVTP");

var $luoAK = parcelRequire("luoAK");
const $64c9d07c3c0e0c95$var$displayPanel = null;
const $64c9d07c3c0e0c95$var$categoriesSearchContainer = null;
const $64c9d07c3c0e0c95$var$categoriesContainer = null;
const $64c9d07c3c0e0c95$var$localizedLinkForCategory = (locale, categoryId)=>{
    const prefix = locale === "en" ? "" : `/${locale}`;
    if (categoryId === "recommended") return `${prefix}/software/confluence/templates`;
    return `${prefix}/software/confluence/templates/categories/${categoryId}`;
}; // eslint-disable-next-line @typescript-eslint/no-empty-function
const $64c9d07c3c0e0c95$var$NOOP = ()=>{};
const $64c9d07c3c0e0c95$var$TemplateCategoriesComponent = ({ categories: categories, onCategoryChange: onCategoryChange, onCategoryChangeIntent: onCategoryChangeIntent })=>{
    const locale = (0, $3FBn4.useLocale)();
    const location = (0, $lrVTP.useLocation)();
    let currentSlug = (0, $luoAK.useCategorySlug)(); // Use default slug if no category is selected and no search term is present.
    currentSlug = (0, $iSvIT.useMemo)(()=>{
        if (!currentSlug) {
            if (new URLSearchParams(location.search).get("term") == null) return 0, $luoAK.DEFAULT_CATEGORY_SLUG;
        }
        return currentSlug;
    }, [
        currentSlug,
        location.search
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1reo1wug _kqsw1if8 _152t8vuz _1pbykb7n _bfhku67f _ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "confluence-template-categories",
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bsb1osq _zulp7vkz"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4Tabs), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            "data-testid": "category-list",
                            className: (0, $esG4f.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlgrho _1ul9idpf _1e0c1txw _zulpftgi _1bah1h6o _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                            ]),
                            children: categories.map((category)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lvNuI.Tile), {
                                        href: $64c9d07c3c0e0c95$var$localizedLinkForCategory(locale, category.urlSlug),
                                        label: category.name,
                                        onFocus: category.urlSlug !== currentSlug ? ()=>onCategoryChangeIntent?.(category.urlSlug) : undefined,
                                        onMouseEnter: category.urlSlug !== currentSlug ? ()=>onCategoryChangeIntent?.(category.urlSlug) : undefined,
                                        onClick: category.urlSlug !== currentSlug ? ()=>onCategoryChange(category.urlSlug) : $64c9d07c3c0e0c95$var$NOOP,
                                        isActive: category.urlSlug === currentSlug,
                                        icon: category.icon,
                                        iconHovered: category.iconHovered
                                    })
                                }, category.urlSlug))
                        })
                    })
                })
            })
        })
    });
};
const $64c9d07c3c0e0c95$export$121dc1a9b075ffc = (0, $1MbAx.withFeatureExposed)("cfind-1795-refresh-template-categories", "enrolled", $64c9d07c3c0e0c95$var$TemplateCategoriesComponent);

});

parcelRegister("6Gqxf", function(module, exports) {

$parcel$export(module.exports, "TemplateCarouselSection", function () { return $a2aa697a5f3a021e$export$52652adcb6c112bc; });
$parcel$export(module.exports, "SectionDivider", function () { return $a2aa697a5f3a021e$export$6d837e605d1c4f23; });
/* template-carousel-section-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $5ohHq = parcelRequire("5ohHq");

var $j81mX = parcelRequire("j81mX");
const $a2aa697a5f3a021e$var$collectionsWrapperStyles = null;
const $a2aa697a5f3a021e$var$sectionDividerStyles = null;
const $a2aa697a5f3a021e$var$templateSectionStyles = null;
const $a2aa697a5f3a021e$var$carouselTitleStyles = null;
const $a2aa697a5f3a021e$var$subTextStyles = null;
const $a2aa697a5f3a021e$export$52652adcb6c112bc = ({ collections: collections })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "template-carousel-section-relay",
        className: (0, $esG4f.default)([
            "_u7coobt3 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _n3tdckbl _1bsb1fra _1e0c1txw _2lx21bp4 _4cvr1h6o _1opx1r39 _g65pko4j _w0lq1gzr _41q616yw _1nbc1u0r _q1ve1yw0 _19xn1v6t _wsqf1c3h"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz413ei _k48pbfng _syazdtn8 _ect41pz4 _19pkidpf _2hwxidpf _otyrftgi _18u0idpf _y3gn1h6o _1cqsviql _1bys11uf"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "confluence.template.carousel.heading",
                    defaultMessage: "Template collections"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "confluence.template.carousel.subtext",
                    defaultMessage: "See curated templates targeted to help achieve work and collaboration goals"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                className: (0, $esG4f.default)([
                    "_1e0c1ule"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j81mX.CollectionCardCarousel), {
                    collections: collections
                })
            })
        ]
    });
};
$a2aa697a5f3a021e$export$52652adcb6c112bc.displayName = "TemplateCarouselSection";
const $a2aa697a5f3a021e$export$6d837e605d1c4f23 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3it94y _11q7u4vp _kqswh2mm _152t1uiu _1bsb1fra _1opx1r39 _g65pko4j _w0lq1gzr _41q616yw _1nbc1u0r _q1ve1yw0 _19xn1v6t _wsqf1c3h _1jco1wug _n3j91wug _bj5y1wug _k2i01wug"
        ]),
        style: {
            "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
        }
    });

});
parcelRegister("j81mX", function(module, exports) {

$parcel$export(module.exports, "CollectionCardCarousel", function () { return $66824e11c5e6ca99$export$66943dda138bdb3; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $vqrsL = parcelRequire("vqrsL");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $7R6zG = parcelRequire("7R6zG");
var $66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment;
const $66824e11c5e6ca99$var$slickStyle = null;
const $66824e11c5e6ca99$var$carouselContainer = null;
const $66824e11c5e6ca99$var$carouselCardWrapper = null;

const $66824e11c5e6ca99$var$CollectionCardCarouselFragment = $66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment !== void 0 ? $66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment : ($66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment = (parcelRequire("9B0nv")), $66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment.hash && $66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment.hash !== "cc3e4db88f751878185d865c8fde82f6" && console.error("The definition of 'collectionCardCarouselRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $66824e11c5e6ca99$var$_collectionCardCarouselRelayFragment);
const $66824e11c5e6ca99$export$66943dda138bdb3 = ({ collections: collections })=>{
    const data = (0, $hOqV7.useFragment)($66824e11c5e6ca99$var$CollectionCardCarouselFragment, collections).edges;
    const settings = (0, $iSvIT.useMemo)(()=>({
            infinite: data.length > 3,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: /*#__PURE__*/ (0, $loA2J.jsx)($66824e11c5e6ca99$var$LeftArrow, {}),
            nextArrow: /*#__PURE__*/ (0, $loA2J.jsx)($66824e11c5e6ca99$var$RightArrow, {}),
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: data.length > 2
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: data.length > 1
                    }
                }
            ]
        }), [
        data.length
    ]);
    const beforeChange = (currentSlide, nextSlide)=>{
        (0, $5VuC0.ConfluenceTemplateAnalytics).sendCollectionCarouselAnalytic(currentSlide, nextSlide, data.length);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1bsb1fra _g65p1feq _41q6v36b _q1vejxaq _wsqf1c3h"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), {
                ...settings,
                beforeChange: beforeChange,
                children: data.map(({ node: collection })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c13la _1bah1h6o _19pkftgi _2hwx7vkz _otyrftgi _18u07vkz _1kpjftgi _1puuftgi _6iqbftgi _1st5ftgi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7R6zG.CollectionCardRelay), {
                            collection: collection
                        })
                    }, collection.collectionId))
            })
        })
    });
};
const $66824e11c5e6ca99$var$buttonLeft = null;
const $66824e11c5e6ca99$var$buttonLeftArrow = null;
const $66824e11c5e6ca99$var$LeftArrow = ({ onClick: onClick })=>{
    const intl = (0, $f6qj2.default)();
    const previousLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselPreviousLabel);
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        "aria-label": previousLabel,
        onClick: onClick,
        className: (0, $esG4f.default)([
            "_bfhku67f _1e0c1ule _kqswstnw _vchhusvi _152t1ssb _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _1n3y1bs0 _1bsb1ylp _4t3i1ylp _1e02myb0"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9eczk8b _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbqmyb0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz _syazvwuj"
            ])
        })
    });
};
const $66824e11c5e6ca99$var$buttonRight = null;
const $66824e11c5e6ca99$var$buttonRightArrow = null;
const $66824e11c5e6ca99$var$RightArrow = ({ onClick: onClick })=>{
    const intl = (0, $f6qj2.default)();
    const nextLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselNextLabel);
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        "aria-label": nextLabel,
        onClick: onClick,
        className: (0, $esG4f.default)([
            "_bfhku67f _vchhusvi _1e0c1ule _kqswstnw _152t1ssb _19itglyw _16qs1a7r _t9ec1krs _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazrbzz _vwz4an13 _1pbykb7n _f43l1bs0 _1bsb1ylp _4t3i1ylp _rjxpmyb0"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_t9ec1hke _1bsb1crf _4t3i1crf _1e0c1o8l _vwz4idpf _kqswstnw _1pfhyjp0 _ahbq1bs0 _vchhusvi _mqm2pqxa _191wpqxa _1wyb7vkz _syazvwuj"
            ])
        })
    });
};

});
parcelRegister("9B0nv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7ff94a22122933e0$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<448413b5fd0560e7708fbec5001a0278>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7ff94a22122933e0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionCardCarouselRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "collectionId",
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "collectionCardRelayFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateCollectionContentSearchConnection",
    "abstractKey": null
};
$7ff94a22122933e0$var$node.hash = "cc3e4db88f751878185d865c8fde82f6";
var $7ff94a22122933e0$export$2e2bcd8739ae039 = $7ff94a22122933e0$var$node;

});



parcelRegister("jFAtB", function(module, exports) {

$parcel$export(module.exports, "TemplateFuzzySearch", function () { return $7811fe357b8c2099$export$6cd85f399bebc53c; });
/* template-fuzzy-search-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $6IiXU = parcelRequire("6IiXU");

var $f448m = parcelRequire("f448m");

var $2YVsr = parcelRequire("2YVsr");

var $7OGW4 = parcelRequire("7OGW4");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $4ktyF = parcelRequire("4ktyF");

var $lKtNn = parcelRequire("lKtNn");

var $e6mpu = parcelRequire("e6mpu");
const $7811fe357b8c2099$var$searchBarContainer = null;
const $7811fe357b8c2099$var$searchBar = null;
const $7811fe357b8c2099$var$searchIconStyle = null;
const $7811fe357b8c2099$var$searchIconResultsStyle = null;
const $7811fe357b8c2099$var$closeButtonStyles = null;
const $7811fe357b8c2099$var$closeIconSectionStyles = null;
const $7811fe357b8c2099$var$TemplateFuzzySearchIcon = /*#__PURE__*/ (0, $iSvIT.memo)(({ variant: variant })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3i1l27 _1bsb4bvh _syaztwqo _1e0c1txw _1bah1h6o _4cvr1h6o",
            variant == "results" && "_sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
            label: intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).searchLabel),
            size: "medium"
        })
    });
});
const $7811fe357b8c2099$var$TemplateFuzzySearchCloseIcon = /*#__PURE__*/ (0, $iSvIT.memo)(({ onClick: onClick })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bahesu3 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _4cvr1h6o _1pfhftgi _szfsglyw _8ycoglyw _g2chglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
            id: "clear-button",
            type: "submit",
            color: "#fff",
            onClick: onClick,
            testId: "clear-button",
            className: (0, $esG4f.default)([
                "_syaztwqo _19itglyw _1o9zidpf _80omtlke"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f448m))), {
                label: intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).closeLabel),
                primaryColor: "#808080",
                size: "medium"
            })
        })
    });
});
const $7811fe357b8c2099$var$SET_INPUT_VALUE = "SET_INPUT_VALUE";
const $7811fe357b8c2099$var$SET_SUGGESTION = "SET_SUGGESTION";
const $7811fe357b8c2099$var$ACCEPT_SUGGESTION = "ACCEPT_SUGGESTION";
const $7811fe357b8c2099$var$HIDE_SUGGESTIONS = "HIDE_SUGGESTIONS";
const $7811fe357b8c2099$var$SHOW_SUGGESTIONS = "SHOW_SUGGESTIONS";
const $7811fe357b8c2099$var$reduceSearchState = (state, action)=>{
    switch(action.type){
        case $7811fe357b8c2099$var$SET_INPUT_VALUE:
            if (action.value !== state.inputValue) return {
                ...state,
                inputValue: action.value,
                shouldShowSuggestions: true
            };
            return state;
        case $7811fe357b8c2099$var$SET_SUGGESTION:
            if (action.value !== state.currentSuggestion) return {
                ...state,
                currentSuggestion: action.value,
                shouldShowSuggestions: true
            };
            return state;
        case $7811fe357b8c2099$var$ACCEPT_SUGGESTION:
            return {
                ...state,
                inputValue: action.value,
                shouldShowSuggestions: false,
                currentSuggestion: null
            };
        case $7811fe357b8c2099$var$HIDE_SUGGESTIONS:
            if (state.shouldShowSuggestions) return {
                ...state,
                shouldShowSuggestions: false
            };
            return state;
        case $7811fe357b8c2099$var$SHOW_SUGGESTIONS:
            if (!state.shouldShowSuggestions) return {
                ...state,
                shouldShowSuggestions: true
            };
            return state;
        default:
            {
                const exhaustiveCheck = action;
                console.error(`Invalid action type ${exhaustiveCheck}`);
                return state;
            }
    }
};
const $7811fe357b8c2099$var$toInputDisplay = (searchTerm)=>{
    if (!searchTerm) return "";
    if (typeof searchTerm === "string") return searchTerm;
    return searchTerm.name ?? "";
};
const $7811fe357b8c2099$var$useSearchState = (initialSearchTerm)=>{
    const [state, dispatch] = (0, $iSvIT.useReducer)($7811fe357b8c2099$var$reduceSearchState, {
        inputValue: initialSearchTerm ?? null,
        shouldShowSuggestions: false
    });
    const actions = (0, $iSvIT.useMemo)(()=>({
            setInputValue: (value)=>{
                dispatch({
                    type: $7811fe357b8c2099$var$SET_INPUT_VALUE,
                    value: value
                });
            },
            acceptSuggestion: (value)=>{
                dispatch({
                    type: $7811fe357b8c2099$var$ACCEPT_SUGGESTION,
                    value: value
                });
            },
            setSuggestion: (value)=>{
                dispatch({
                    type: $7811fe357b8c2099$var$SET_SUGGESTION,
                    value: value
                });
            },
            hideSuggestions: ()=>{
                dispatch({
                    type: $7811fe357b8c2099$var$HIDE_SUGGESTIONS
                });
            },
            showSuggestions: ()=>{
                dispatch({
                    type: $7811fe357b8c2099$var$SHOW_SUGGESTIONS
                });
            }
        }), []);
    return (0, $iSvIT.useMemo)(()=>[
            state,
            actions
        ], [
        state,
        actions
    ]);
};
const $7811fe357b8c2099$export$6cd85f399bebc53c = ({ value: value, onSubmit: onSubmit })=>{
    const intl = (0, $f6qj2.default)();
    const [{ inputValue: inputValue, currentSuggestion: currentSuggestion, shouldShowSuggestions: shouldShowSuggestions }, { setInputValue: setInputValue, setSuggestion: setSuggestion, acceptSuggestion: acceptSuggestion, hideSuggestions: hideSuggestions, showSuggestions: showSuggestions }] = $7811fe357b8c2099$var$useSearchState(value);
    const searchRef = (0, $iSvIT.useRef)(null);
    const inputRef = (0, $iSvIT.useRef)(null);
    const hasSentAnalytic = (0, $iSvIT.useRef)(false);
    const onSubmitRef = (0, $iSvIT.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [suggestions, loadSuggestionsQuery] = (0, $e6mpu.useSearchSuggestionsLoader)();
    const [, startLoadSuggestions] = (0, $iSvIT.useTransition)(); // Hide suggestions when the search term changes.
    (0, $iSvIT.useEffect)(hideSuggestions, [
        hideSuggestions,
        value
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!shouldShowSuggestions) return; //Handling clicking outside the suggestion list, so it automatically closes when not the focus
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) hideSuggestions();
        };
        const handleEsc = (event)=>{
            if (event.key === "Escape") hideSuggestions();
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEsc, false);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEsc, false);
        };
    }, [
        hideSuggestions,
        shouldShowSuggestions
    ]);
    const handleInputChange = (event)=>{
        event.preventDefault(); // Send analytics data only the first time
        if (!hasSentAnalytic.current) {
            (0, $5VuC0.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchAnalytic();
            hasSentAnalytic.current = true; // Set the flag to true after the first call
        }
        setInputValue(event?.target?.value);
    };
    const handleInputFocus = ()=>{
        if (!suggestions) startLoadSuggestions(loadSuggestionsQuery);
        (0, $5VuC0.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchFocusAnalytic();
        showSuggestions();
    };
    const handleMouseEnter = ()=>{
        if (!suggestions) startLoadSuggestions(loadSuggestionsQuery);
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Enter") {
            if (inputValue) onSubmitRef.current?.(inputValue);
        }
    };
    const handleSuggestionClick = (suggestion)=>{
        acceptSuggestion(suggestion);
        if (suggestion) onSubmitRef.current?.(suggestion);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _1q511u1b"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            ref: searchRef,
            className: (0, $esG4f.default)([
                "_19itgzvk _1bsb1fa8 _4t3i1mcy _2rko1v6z _bfhku67f _w4ky1y6m _125x7vkz _yizh1nn1 _1r1b1tcg _psgkr3uz _1heulnmy _1ru31q9c _1yzy15vq _bgrh15vq _509t1l2s _wr7noxwj _1hr2dgin _12rrdgin _7bcc12aa _1qwo12aa"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), {
                    ref: inputRef,
                    id: "templates-fuzzy-search-input",
                    testId: "templates-fuzzy-search-input",
                    placeholder: intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).fuzzySearchInputText),
                    onChange: handleInputChange,
                    onFocus: handleInputFocus,
                    onMouseEnter: handleMouseEnter,
                    onKeyDown: handleKeyDown,
                    value: $7811fe357b8c2099$var$toInputDisplay(inputValue),
                    autoComplete: "off",
                    role: "combobox",
                    "aria-label": intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).fuzzySearchAriaLabel),
                    "aria-haspopup": "listbox",
                    "aria-owns": "suggestion-box",
                    "aria-expanded": shouldShowSuggestions,
                    "aria-activedescendant": currentSuggestion ? `option-${currentSuggestion.id}` : undefined,
                    elemBeforeInput: /*#__PURE__*/ (0, $loA2J.jsx)($7811fe357b8c2099$var$TemplateFuzzySearchIcon, {}),
                    elemAfterInput: inputValue ? /*#__PURE__*/ (0, $loA2J.jsx)($7811fe357b8c2099$var$TemplateFuzzySearchCloseIcon, {
                        onClick: ()=>setInputValue(null)
                    }) : null
                }),
                shouldShowSuggestions && suggestions && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
                    fallback: /*#__PURE__*/ (0, $loA2J.jsx)("div", {}),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                        fallback: inputValue && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lKtNn.TemplateFuzzySearchSuggestionsLoading), {}),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lKtNn.TemplateFuzzySearchSuggestions), {
                            suggestions: suggestions,
                            currentSuggestion: currentSuggestion,
                            inputValue: inputValue,
                            onSelect: setSuggestion,
                            onSubmit: handleSuggestionClick
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("lKtNn", function(module, exports) {

$parcel$export(module.exports, "TemplateFuzzySearchSuggestions", function () { return $4930531716eb3eab$export$71b42e992a111c35; });
$parcel$export(module.exports, "TemplateFuzzySearchSuggestionsLoading", function () { return $4930531716eb3eab$export$92f6255a57b0e383; });
/* template-fuzzy-search-suggestions-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $2YVsr = parcelRequire("2YVsr");

var $8xSOc = parcelRequire("8xSOc");

var $9gh2a = parcelRequire("9gh2a");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $e6mpu = parcelRequire("e6mpu");
const $4930531716eb3eab$var$suggestionContainerStyle = null;
const $4930531716eb3eab$var$suggestionSpinnerStyle = null;
const $4930531716eb3eab$var$suggestionListStyle = null;
const $4930531716eb3eab$var$suggestionItemStyle = null;
const $4930531716eb3eab$var$searchIconStyle = null;
const $4930531716eb3eab$var$searchIconResultsStyle = null;
const $4930531716eb3eab$var$TemplateFuzzySearchIcon = /*#__PURE__*/ (0, $iSvIT.memo)(({ variant: variant })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3i1l27 _1bsb4bvh _syaztwqo _1e0c1txw _1bah1h6o _4cvr1h6o",
            variant == "results" && "_sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2YVsr))), {
            label: intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).searchLabel),
            size: "medium"
        })
    });
});
const $4930531716eb3eab$var$SuggestionItem = ({ suggestion: suggestion })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($4930531716eb3eab$var$TemplateFuzzySearchIcon, {
                variant: "results"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bah1y6m _1wyb1j6v _k48pbfng _vwz41tcg _syazr3uz _ect4lnmy _ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt _1cqsoxwj"
                ]),
                children: suggestion.name
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
                children: [
                    suggestion.type === "category" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                        appearance: "success",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "confluence.main.area.cfind.fuzzysearch.label.category",
                            defaultMessage: "CATEGORY"
                        })
                    }),
                    suggestion.type === "template" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                        appearance: "inprogress",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "confluence.main.area.cfind.fuzzysearch.label.template",
                            defaultMessage: "TEMPLATE"
                        })
                    })
                ]
            })
        ]
    });
};
const $4930531716eb3eab$var$currentSuggestionIsValid = (currentSuggestion, suggestions)=>{
    if (!currentSuggestion) return true;
    if (!suggestions) return false;
    return suggestions.includes(currentSuggestion);
};
const $4930531716eb3eab$var$nextSuggestion = (suggestions, currentSuggestion, onSelect)=>{
    if (!onSelect) return;
    let nextSuggestion = suggestions?.[0] ?? null;
    if (currentSuggestion) {
        const index = suggestions?.indexOf(currentSuggestion) ?? -1;
        if (index > -1) nextSuggestion = suggestions?.[index + 1] ?? currentSuggestion;
    }
    onSelect?.(nextSuggestion);
};
const $4930531716eb3eab$var$prevSuggestion = (suggestions, currentSuggestion, onSelect)=>{
    if (!onSelect) return;
    let prevSuggestion = suggestions?.[suggestions.length - 1] ?? null;
    if (currentSuggestion) {
        const index = suggestions?.indexOf(currentSuggestion) ?? -1;
        if (index > -1) prevSuggestion = suggestions?.[index - 1] ?? currentSuggestion;
    }
    onSelect?.(prevSuggestion);
};
const $4930531716eb3eab$var$acceptSuggestion = (suggestion, onSubmit)=>{
    onSubmit?.(suggestion);
    (0, $5VuC0.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchPreviewAnalytic(// @ts-ignore: SearchSuggestion is a union type roughly equivalent to TemplateSearchItem
    suggestion);
};
const $4930531716eb3eab$export$71b42e992a111c35 = ({ currentSuggestion: currentSuggestion, suggestions: queryRef, inputValue: inputValue, onSubmit: onSubmit, onSelect: onSelect })=>{
    const suggestions = (0, $e6mpu.useSearchSuggestions)(queryRef, inputValue);
    (0, $iSvIT.useEffect)(()=>{
        if (currentSuggestion) document.getElementById(`option-${currentSuggestion.id}`)?.scrollIntoView({
            block: "nearest",
            inline: "nearest"
        });
    }, [
        currentSuggestion
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "ArrowDown") {
                event.preventDefault();
                $4930531716eb3eab$var$nextSuggestion(suggestions, currentSuggestion, onSelect);
            } else if (event.key === "ArrowUp") {
                event.preventDefault();
                $4930531716eb3eab$var$prevSuggestion(suggestions, currentSuggestion, onSelect);
            } else if (event.key === "Enter") {
                if (currentSuggestion) {
                    event.preventDefault();
                    $4930531716eb3eab$var$acceptSuggestion(currentSuggestion, onSubmit);
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        suggestions,
        currentSuggestion,
        onSelect,
        onSubmit
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (inputValue) (0, $5VuC0.ConfluenceTemplateAnalytics).sendTemplateFuzzySearchResultsAnalytic((suggestions?.length ?? 0).toString());
    }, [
        inputValue,
        suggestions
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!$4930531716eb3eab$var$currentSuggestionIsValid(currentSuggestion, suggestions)) onSelect?.(null);
    }, [
        currentSuggestion,
        suggestions,
        onSelect
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: "suggestion-box",
        "data-testid": "template-fuzzy-search-suggestions",
        role: "listbox",
        "aria-labelledby": currentSuggestion ? `option-${currentSuggestion.id}` : undefined,
        className: (0, $esG4f.default)([
            "_bfhku67f _19it8ned _kdam152l _y3gn1e5h _1wpz1fhb _c71l37m0 _18m91wug _kqswh2mm _1pbycs5v _2rko1v6z"
        ]),
        children: suggestions?.map((suggestion)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                id: `option-${suggestion.id}`,
                // eslint-disable-next-line jsx-a11y/aria-role
                role: "value",
                "aria-label": `Select ${suggestion.name}`,
                "aria-selected": currentSuggestion?.id === suggestion.id,
                onClick: ()=>$4930531716eb3eab$var$acceptSuggestion(suggestion, onSubmit),
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _80omtlke _irr335wh _1fpi35wh _jomr35wh _1di635wh _v73619bv _chtu19bv _nssp1yb4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)($4930531716eb3eab$var$SuggestionItem, {
                    suggestion: suggestion
                })
            }, suggestion.id))
    });
};
const $4930531716eb3eab$export$92f6255a57b0e383 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        id: "suggestion-box",
        "data-testid": "template-fuzzy-search-suggestions",
        role: "listbox",
        className: (0, $esG4f.default)([
            "_bfhku67f _19it8ned _kdam152l _y3gn1e5h _1wpz1fhb _c71l37m0 _18m91wug _kqswh2mm _1pbycs5v _2rko1v6z"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            role: "alert",
            "aria-label": "Loading",
            "data-testid": "template-fuzzy-search-suggestions-spinner",
            className: (0, $esG4f.default)([
                "_ca0qftgi _u5f3i2wt _n3tdftgi _19bvi2wt"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {})
        })
    });
};

});
parcelRegister("e6mpu", function(module, exports) {

$parcel$export(module.exports, "FUSE_OPTIONS", function () { return $a1df89095481a56f$export$3f017e5a86c4357e; });
$parcel$export(module.exports, "parseTemplateSearchItems", function () { return $a1df89095481a56f$export$40e6048120e8f1aa; });
$parcel$export(module.exports, "parseCategorySearchItems", function () { return $a1df89095481a56f$export$c4f88d3d4eb94ce2; });
$parcel$export(module.exports, "UseSearchSuggestionsQuery", function () { return $a1df89095481a56f$export$815a5dab52bbf225; });
$parcel$export(module.exports, "useSearchSuggestionsLoader", function () { return $a1df89095481a56f$export$a5b5215eff520376; });
$parcel$export(module.exports, "useSearchSuggestions", function () { return $a1df89095481a56f$export$688cc0524c0f6b2f; });

var $iSvIT = parcelRequire("iSvIT");

var $iooib = parcelRequire("iooib");

var $hOqV7 = parcelRequire("hOqV7");

var $a8pnN = parcelRequire("a8pnN");
var $a1df89095481a56f$var$_useSearchSuggestionsQuery;
const $a1df89095481a56f$export$3f017e5a86c4357e = {
    keys: [
        {
            name: "name",
            weight: 0.8
        },
        // Increased weight for better matches on name
        {
            name: "description",
            weight: 0.5
        },
        {
            name: "contributor",
            weight: 0.3
        },
        {
            name: "contributorOrganization",
            weight: 0.3
        },
        {
            name: "customTag",
            weight: 0.3
        }
    ],
    includeScore: true,
    threshold: 0.4
};
const $a1df89095481a56f$var$FUSE_RESULT_LIMIT = 35;
const $a1df89095481a56f$var$SLUG_TO_TAGS = {
    "project-plan": [
        "proposal",
        "gantt",
        "timeline"
    ],
    "master-project-documentation": [
        "proposal"
    ],
    "annual-plan-one-pager": [
        "proposal"
    ],
    "mutual-action-plan": [
        "proposal"
    ],
    "executive-business-review": [
        "proposal"
    ],
    "devops-runbook": [
        "gantt",
        "timeline"
    ],
    "software-architecture-review": [
        "gantt"
    ],
    "problem-framing": [
        "faq"
    ],
    "safe-lean-business-case": [
        "faq"
    ],
    "hr-knowledge-base": [
        "faq"
    ],
    "design-sprint": [
        "timeline"
    ],
    "project-kickoff": [
        "timeline"
    ],
    "year-in-review": [
        "timeline"
    ]
};
const $a1df89095481a56f$export$228c248010eea3fe = "1HlskYfRNciSnQ02SDhCPs";
const $a1df89095481a56f$var$getAuthor = (template)=>{
    return template.contributor?.__typename === "ContentPlatformAuthor" ? template.contributor : null;
};
const $a1df89095481a56f$var$getOrganization = (template)=>{
    return template.contributor?.__typename === "ContentPlatformOrganization" ? template.contributor : template.contributor?.__typename === "ContentPlatformAuthor" ? template.contributor?.organization : null;
};
const $a1df89095481a56f$var$addCustomTagToTemplatesBasedOnSearchTerm = (template)=>{
    const tags = (template.urlSlug ? $a1df89095481a56f$var$SLUG_TO_TAGS[template.urlSlug] : []) ?? [];
    /**
   * Whiteboard templates for custom tag search term "whiteboard templates"
   */ if (template.templateType?.some((type)=>type.id === $a1df89095481a56f$export$228c248010eea3fe)) tags.push("whiteboard templates");
    return tags;
};
const $a1df89095481a56f$export$40e6048120e8f1aa = (templates)=>{
    const items = [];
    for (const { node: template } of templates.edges)if (template.urlSlug) items.push({
        id: template.urlSlug,
        name: template.name,
        description: template.previewBlurb,
        contributor: $a1df89095481a56f$var$getAuthor(template)?.name,
        contributorOrganization: $a1df89095481a56f$var$getOrganization(template)?.name,
        customTag: $a1df89095481a56f$var$addCustomTagToTemplatesBasedOnSearchTerm(template),
        type: "template",
        templateType: template.templateType?.[0]?.templateTypeName
    });
    return items;
};
const $a1df89095481a56f$export$c4f88d3d4eb94ce2 = (categories)=>{
    const items = [];
    for (const { node: node } of categories.edges)if (node.context.urlSlug !== "featured" && node.context.urlSlug !== "recommended" && node.context.urlSlug !== "project-planning" && node.context.urlSlug !== "business-strategy" && node.context.urlSlug !== "productivity" && node.context.urlSlug !== "docs-and-reports" && node.context.urlSlug !== "startup" && node.context.urlSlug !== "personal") items.push({
        id: node.context.urlSlug,
        name: node.context.name,
        description: node.context.shortDescriptionOneLiner,
        type: "category"
    });
    return items;
};

const $a1df89095481a56f$export$815a5dab52bbf225 = $a1df89095481a56f$var$_useSearchSuggestionsQuery !== void 0 ? $a1df89095481a56f$var$_useSearchSuggestionsQuery : ($a1df89095481a56f$var$_useSearchSuggestionsQuery = (parcelRequire("9saDM")), $a1df89095481a56f$var$_useSearchSuggestionsQuery.hash && $a1df89095481a56f$var$_useSearchSuggestionsQuery.hash !== "372493189502e6e89c2d5588ed4b3bc2" && console.error("The definition of 'useSearchSuggestionsQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $a1df89095481a56f$var$_useSearchSuggestionsQuery);
const $a1df89095481a56f$export$a5b5215eff520376 = ()=>{
    const locale = (0, $a8pnN.useQueryLocale)();
    const [queryRef, loadQuery] = (0, $hOqV7.useQueryLoader)($a1df89095481a56f$export$815a5dab52bbf225);
    const loadSearchSuggestionsQuery = (0, $iSvIT.useCallback)(()=>{
        loadQuery({
            locale: locale
        });
    }, [
        loadQuery,
        locale
    ]);
    return [
        queryRef,
        loadSearchSuggestionsQuery
    ];
};
const $a1df89095481a56f$export$688cc0524c0f6b2f = (queryRef, inputValue)=>{
    const { categories: categories, templates: templates } = (0, $hOqV7.usePreloadedQuery)($a1df89095481a56f$export$815a5dab52bbf225, queryRef);
    const fuse = (0, $iSvIT.useMemo)(()=>new (0, $iooib.default)([
            ...$a1df89095481a56f$export$40e6048120e8f1aa(templates),
            ...$a1df89095481a56f$export$c4f88d3d4eb94ce2(categories)
        ], $a1df89095481a56f$export$3f017e5a86c4357e), [
        templates,
        categories
    ]);
    return (0, $iSvIT.useMemo)(()=>{
        let results = [];
        if (inputValue) results = fuse.search(typeof inputValue === "string" ? inputValue : inputValue?.name ?? "").sort((a, b)=>(a.score ?? Infinity) - (b.score ?? Infinity)) // Sort by score in ascending order
        .slice(0, $a1df89095481a56f$var$FUSE_RESULT_LIMIT) // Get the top results
        .map((result)=>result.item);
        return results;
    }, [
        fuse,
        inputValue
    ]);
};

});
parcelRegister("9saDM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $77236ca8def9706e$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<9c3ff714af84a4867da0be7a82593364>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $77236ca8def9706e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        }
    ], v1 = {
        "items": [
            {
                "kind": "Variable",
                "name": "withLocales.0",
                "variableName": "locale"
            }
        ],
        "kind": "ListValue",
        "name": "withLocales"
    }, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = [
        {
            "alias": null,
            "args": [
                {
                    "fields": [
                        {
                            "items": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 200
                                        },
                                        v1 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "queries.0"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "queries"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "search"
                }
            ],
            "concreteType": "ContentPlatformTemplateContentSearchConnection",
            "kind": "LinkedField",
            "name": "templates",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateResultEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "urlSlug",
                                    "storageKey": null
                                },
                                v2 /*: any*/ ,
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previewBlurb",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTaxonomyTemplateType",
                                    "kind": "LinkedField",
                                    "name": "templateType",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "templateTypeName",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "contributor",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v3 /*: any*/ ,
                                            "type": "ContentPlatformOrganization",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformOrganization",
                                                    "kind": "LinkedField",
                                                    "name": "organization",
                                                    "plural": false,
                                                    "selections": v3 /*: any*/ ,
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "ContentPlatformAuthor",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": "categories",
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 25
                },
                {
                    "kind": "Literal",
                    "name": "forContentType",
                    "value": "Template"
                },
                {
                    "kind": "Literal",
                    "name": "forFields",
                    "value": [
                        "category"
                    ]
                },
                v1 /*: any*/ 
            ],
            "concreteType": "ContentPlatformContentFacetConnection",
            "kind": "LinkedField",
            "name": "contentFacet",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformContentFacet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "context",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "metadata": null,
            "name": "useSearchSuggestionsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSearchSuggestionsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c9eb57783afee61790d472617c9d9adb",
            "id": null,
            "metadata": {},
            "name": "useSearchSuggestionsQuery",
            "operationKind": "query",
            "text": 'query useSearchSuggestionsQuery(\n  $locale: String!\n) {\n  templates(search: {queries: [{first: 200, withLocales: [$locale]}]}) {\n    edges {\n      node {\n        urlSlug\n        name\n        previewBlurb\n        templateType {\n          id\n          templateTypeName\n        }\n        contributor {\n          __typename\n          ... on ContentPlatformOrganization {\n            name\n          }\n          ... on ContentPlatformAuthor {\n            name\n            organization {\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n  categories: contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: [$locale]) {\n    edges {\n      node {\n        context\n      }\n    }\n  }\n}\n'
        }
    };
}();
$77236ca8def9706e$var$node.hash = "372493189502e6e89c2d5588ed4b3bc2";
var $77236ca8def9706e$export$2e2bcd8739ae039 = $77236ca8def9706e$var$node;

});




parcelRegister("3elnn", function(module, exports) {

$parcel$export(module.exports, "TemplateHeroSection", function () { return $6521462f9445a7ef$export$c4846c3d98668d95; });
/* template-hero-section-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $1XyNv = parcelRequire("1XyNv");

var $5ohHq = parcelRequire("5ohHq");
const $6521462f9445a7ef$var$containerStyles = null;
const $6521462f9445a7ef$var$variantHeaderStyles = null;
const $6521462f9445a7ef$var$titleStyles = null;
const $6521462f9445a7ef$var$subTitleStyles = null;
const $6521462f9445a7ef$export$c4846c3d98668d95 = ({ categoryName: categoryName, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("header", {
            className: (0, $esG4f.default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o _2rkogktf _1mou66rk _18zr1y44 _1bsb15ao _11q73dpe _syazcd5j _4t3i1hiv _195gcae7 _91qczwfg _1n041tcg _15sjkpet _t95d7vkz"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect41pz4 _k48pbfng _1wyb1ex1 _1cqs14no"
                    ]),
                    style: {
                        "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                    },
                    children: categoryName ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        ...(0, $1XyNv.ConfluenceTemplateMessages).headerText,
                        values: {
                            categoryName: categoryName
                        }
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        ...(0, $1XyNv.ConfluenceTemplateMessages).defaultHeaderText
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48p1nn1 _1wybgktf _1cqs7vkz _1rfm122r"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        ...(0, $1XyNv.ConfluenceTemplateMessages).subHeaderText
                    })
                }),
                children
            ]
        })
    });
};
$6521462f9445a7ef$export$c4846c3d98668d95.displayName = "TemplateHeroSection";

});

parcelRegister("hPIpb", function(module, exports) {

$parcel$export(module.exports, "TemplateLearnFromLeadersSection", function () { return $7790ae1af16835ee$export$2ae50b08eee2162f; });
/* template-learn-from-leaders-section-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $hJvDR = parcelRequire("hJvDR");

var $24jZj = parcelRequire("24jZj");
const $7790ae1af16835ee$var$sectionStyles = null;
const $7790ae1af16835ee$var$textContentSection = null;
const $7790ae1af16835ee$var$headerStyles = null;
const $7790ae1af16835ee$var$partnerSectionStyles = null;
const $7790ae1af16835ee$export$2ae50b08eee2162f = ({ templates: templates, categories: categories })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        "data-testid": "template-learn-from-leaders-section-relay",
        className: (0, $esG4f.default)([
            "_kqswh2mm _ca0qzwfg _u5f3idpf _n3tdidpf _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1itksawm _1lrw1dfr _12vemgnk _ouxlyfq0 _kqswh2mm _1pbykb7n"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_syaz1sq1 _ca0q1ylp _otyr1wqb _y3gn1h6o _vwz4ckbl _ect41td8 _1wyb1ylp _k48p1fw0 _g65po812 _r9upidpf _1sr21wug _f4g41ylp _101c1wug _16et1k8s _41q6weo2 _ef9cidpf _tnim1wug _sw271ylp _1q5p1wug _q1veweo2 _xam0idpf _6b6x1wug _r1061ylp _po3f1wug"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "confluence.templates.learn.from.industry.leaders",
                            defaultMessage: "Learn from industry leaders"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f3idpf _n3td1obz _19bvn0up"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hJvDR.PartnerTemplateCardCarousel), {
                            templates: templates
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $24jZj.AdditionalCategoriesSection), {
                categories: categories
            })
        ]
    });
};
$7790ae1af16835ee$export$2ae50b08eee2162f.displayName = "TemplateLearnFromLeadersSection";

});
parcelRegister("hJvDR", function(module, exports) {

$parcel$export(module.exports, "PartnerTemplateCardCarousel", function () { return $19d68132b1293ef3$export$ef1cff7c35a5b4cd; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $vqrsL = parcelRequire("vqrsL");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $6iG4y = parcelRequire("6iG4y");

var $fN425 = parcelRequire("fN425");
var $19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment;
const $19d68132b1293ef3$var$slickStyle = null;
const $19d68132b1293ef3$var$carouselContainer = null;
const $19d68132b1293ef3$var$carouselCardWrapper = null;
const $19d68132b1293ef3$var$buttonLeft = null;
const $19d68132b1293ef3$var$buttonRight = null;
const $19d68132b1293ef3$var$buttonLeftArrow = null;
const $19d68132b1293ef3$var$buttonRightArrow = null;
const $19d68132b1293ef3$var$buttonRoundedArrow = null;
const $19d68132b1293ef3$var$buttonRoundedLeftArrow = null;
const $19d68132b1293ef3$var$buttonRoundedRightArrow = null;

const $19d68132b1293ef3$var$PartnerTemplateCardCarouselFragment = $19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment !== void 0 ? $19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment : ($19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment = (parcelRequire("7O6iX")), $19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment.hash && $19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment.hash !== "1c7e3f5a4cc2391a481ac057c9b64369" && console.error("The definition of 'partnerTemplateCardCarouselRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $19d68132b1293ef3$var$_partnerTemplateCardCarouselRelayFragment);
const $19d68132b1293ef3$export$ef1cff7c35a5b4cd = ({ templates: templates })=>{
    const data = (0, $hOqV7.useFragment)($19d68132b1293ef3$var$PartnerTemplateCardCarouselFragment, templates).edges;
    const partnerTemplates = (0, $iSvIT.useMemo)(()=>data.map(({ node: node })=>node).sort((a, b)=>(0, $6iG4y.partnerTemplatesDataUrlSlugs).indexOf(a.urlSlug ?? "") - (0, $6iG4y.partnerTemplatesDataUrlSlugs).indexOf(b.urlSlug ?? "")), [
        data
    ]);
    const intl = (0, $f6qj2.default)();
    const previousLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselPreviousLabel);
    const nextLabel = intl.formatMessage((0, $1XyNv.ConfluenceTemplateMessages).carouselNextLabel);
    const LeftArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
            onClick: onClick,
            className: (0, $esG4f.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _1e02101a _bfhk1j28 _g7fridpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": previousLabel,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_t9eczk8b _1bsb1crf _4t3i1crf _vwz4grho _kqswstnw _1pfhyjp0 _mqm2pqxa _191wpqxa _g1edpqxa _syazvwuj _1wyb7vkz"
                ])
            })
        });
    const RightArrow = ({ onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
            onClick: onClick,
            className: (0, $esG4f.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _rjxp101a _bfhk1j28 _z1s5idpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": nextLabel,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_t9ec1hke _1bsb1crf _4t3i1crf _vwz4grho _kqswstnw _1pfhyjp0 _mqm2pqxa _191wpqxa _syazvwuj _1wyb7vkz"
                ])
            })
        });
    const LeftArrowRounded = ({ onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
            onClick: onClick,
            className: (0, $esG4f.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _1e02101a _bfhk1j28 _g7fridpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": previousLabel,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1bsb1crf _4t3i1crf _1e0c1o8l _vwz4t94y _kqswstnw _1pfhyjp0 _vchhusvi _mqm2pqxa _191wpqxa _g1edpqxa _syazrbzz _1wyb7vkz",
                    "_t9eczk8b _ahbqmyb0"
                ])
            })
        });
    const RightArrowRounded = ({ onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
            onClick: onClick,
            className: (0, $esG4f.default)([
                "_1e0c1ule _kqswstnw _152t1ssb _1bsbzwfg _4t3izwfg _19it8cnq _t9ecovhh _2rko1ssb _12ji1r31 _1qu2glyw _12y31o36 _80omtlke _syazvwuj _vwz4an13 _rjxp101a _bfhk1j28 _z1s5idpf _lsvakb7n _1jq9u67f _1xq41a7r",
                "doNotAutoTrack"
            ]),
            "aria-label": nextLabel,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_1bsb1crf _4t3i1crf _1e0c1o8l _vwz4t94y _kqswstnw _1pfhyjp0 _vchhusvi _mqm2pqxa _191wpqxa _g1edpqxa _syazrbzz _1wyb7vkz",
                    "_t9ec1hke _ahbq1bs0"
                ])
            })
        });
    const settings = {
        prevArrow: /*#__PURE__*/ (0, $loA2J.jsx)(LeftArrow, {}),
        nextArrow: /*#__PURE__*/ (0, $loA2J.jsx)(RightArrow, {}),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    prevArrow: /*#__PURE__*/ (0, $loA2J.jsx)(LeftArrowRounded, {}),
                    nextArrow: /*#__PURE__*/ (0, $loA2J.jsx)(RightArrowRounded, {})
                }
            }
        ]
    };
    const beforeChange = (currentSlide, nextSlide)=>{
        (0, $5VuC0.ConfluenceTemplateAnalytics).sendPartnerCarouselAnalytic(currentSlide, nextSlide, partnerTemplates.length);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1bsb4tsx _19pkidpf _2hwx1wug _otyridpf _18u01wug _vnwpsb0t _1x9m1y37 _ppgvweo2 _5251idpf _11ad1wug _sdb5idpf _fdc01wug _wsqf5o3v"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), {
                ...settings,
                beforeChange: beforeChange,
                children: partnerTemplates.map((partnerTemplate)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1o8l _1bsb1osq"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fN425.PartnerTemplateCard), {
                            template: partnerTemplate
                        })
                    }, partnerTemplate.templateId))
            })
        })
    });
};

});
parcelRegister("fN425", function(module, exports) {

$parcel$export(module.exports, "PartnerTemplateCard", function () { return $5d80a2484f2688c4$export$bf388d2348a06d1b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $hOqV7 = parcelRequire("hOqV7");

var $5VuC0 = parcelRequire("5VuC0");

var $8Wj8Y = parcelRequire("8Wj8Y");

var $3FBn4 = parcelRequire("3FBn4");

var $6iG4y = parcelRequire("6iG4y");
var $5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment;
const $5d80a2484f2688c4$export$589d68befb1fa281 = '"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $5d80a2484f2688c4$export$b2dcbe10044f9854 = '"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI",Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important';
const $5d80a2484f2688c4$var$partnerTemplateCardWrapperStyles = null;
const $5d80a2484f2688c4$var$partnerTemplateCardContentStyles = null;
const $5d80a2484f2688c4$var$partnerTemplateCardLogoStyles = null;
const $5d80a2484f2688c4$var$partnerTemplateCardInfoStyles = null;
const $5d80a2484f2688c4$var$partnerTemplateCardTitleStyles = null;
const $5d80a2484f2688c4$var$partnerTemplateCardDescriptionStyles = null;
const $5d80a2484f2688c4$var$cardLink = null;

const $5d80a2484f2688c4$var$PartnerTemplateCardFragment = $5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment !== void 0 ? $5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment : ($5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment = (parcelRequire("702Ic")), $5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment.hash && $5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment.hash !== "c7b0e5760ebc3d3c1db72981228ffb0c" && console.error("The definition of 'partnerTemplateCardRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $5d80a2484f2688c4$var$_partnerTemplateCardRelayFragment);
const $5d80a2484f2688c4$export$bf388d2348a06d1b = ({ template: template })=>{
    const data = (0, $hOqV7.useFragment)($5d80a2484f2688c4$var$PartnerTemplateCardFragment, template); // Note that some fields are still using the existing hardcoded partner template data,
    // as the images or icons are not rendering properly.
    const testData = (0, $iSvIT.useMemo)(()=>{
        const testData = (0, $6iG4y.testPartnerTemplatesData).find((x)=>x.urlSlug === data.urlSlug); // Use CPAPI data where possible, otherwise use hardcoded data
        return {
            templateId: data.templateId,
            name: data.name,
            urlSlug: data.urlSlug,
            partnerDescription: data.oneLinerHeadline,
            contributor: testData?.contributor,
            previewBlurb: data.oneLinerHeadline,
            templateIcon: testData?.templateIcon,
            partnerImage: testData?.partnerImage
        };
    }, [
        data
    ]);
    const intl = (0, $f6qj2.default)();
    const localizedHref = (0, $3FBn4.useLocalizedHref)(`/software/confluence/templates/${testData.urlSlug}`);
    const partnerTemplateImageStyles = null;
    const viewTemplateText = intl.formatMessage({
        id: "confluence.templates.partner-template-card.view-link",
        defaultMessage: "View template"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _19pkidpf _2hwxgktf _otyridpf _18u0gktf _16qso5yx _1sag1bp4 _11nd1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1bsb1y37 _4t3i1kdj _ouxl1ssb _1lrw1dfr _nnst1osq _4mbad36x _nvs81ssb _1itkae7d"
                ]),
                style: {
                    "--_1h6fgdw": (0, $43MIc.default)(testData.partnerImage?.url, ")", "url(")
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1y37 _2lx21bp4 _1bah1yb4 _4cvr1y6m _ca0q1ylp _u5f31ylp _n3td1ylp _19bv1ylp _bfhku67f _nnst1osq _4mbao812 _y65n1ylp _1qavgktf _15y9gktf _p4rcgktf _1k331ssb"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                        src: testData.templateIcon?.url,
                        alt: `${testData.contributor?.name || "Partner"} logo`,
                        className: (0, $esG4f.default)([
                            "_p12fuuw1 _c71l1ylp _1bsb1wug _4t3i1wug _s7n4yfq0 _4mbazwfg"
                        ])
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1yb4 _4cvr1y6m _4t3i13i4 _4mba1j4a"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1tcg _k48pbfng _1dyzdky6 _syaz1alj _ect41lim _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1v87gktf _1nmnea0t _kuia1tcg"
                                ]),
                                children: testData.name
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                className: (0, $esG4f.default)([
                                    "_1wybgktf _vwz41tcg _syazalr3 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ect411r6 _1v877vkz _kuia7vkz _1nmnea0t _6drocj1k _b6pb1e54 _sxdqqfx8 _1ajf15vq _blov15vq _uelygktf"
                                ]),
                                children: testData.partnerDescription
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1ule _syazrbzz _k48pbfng _1pbykb7n _vwz4kb7n _ect411r6 _1v871crf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Wj8Y.Link), {
                                    text: viewTemplateText,
                                    href: localizedHref,
                                    dataEventProps: {
                                        ...(0, $5VuC0.ConfluenceTemplateAnalytics).viewPartnerTemplate(testData.urlSlug),
                                        "data-event": "clicked",
                                        "data-event-component": "link"
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("702Ic", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ab428c09769db3f0$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<f5c6c189aa2e532d57121eac1fb6ec0f>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab428c09769db3f0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "partnerTemplateCardRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlSlug",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplate",
    "abstractKey": null
};
$ab428c09769db3f0$var$node.hash = "c7b0e5760ebc3d3c1db72981228ffb0c";
var $ab428c09769db3f0$export$2e2bcd8739ae039 = $ab428c09769db3f0$var$node;

});


parcelRegister("7O6iX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ccd5446b4474a883$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<6a17d02fcdc308888027ab33a60098fc>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ccd5446b4474a883$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "partnerTemplateCardCarouselRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "templateId",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "urlSlug",
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "partnerTemplateCardRelayFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateContentSearchConnection",
    "abstractKey": null
};
$ccd5446b4474a883$var$node.hash = "1c7e3f5a4cc2391a481ac057c9b64369";
var $ccd5446b4474a883$export$2e2bcd8739ae039 = $ccd5446b4474a883$var$node;

});


parcelRegister("24jZj", function(module, exports) {

$parcel$export(module.exports, "AdditionalCategoriesSection", function () { return $cd98434c038b20e4$export$5770244d10930a; });
/* additional-categories-section-relay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $cd98434c038b20e4$var$containerStyles = null;
const $cd98434c038b20e4$var$additionalCategoriesTextStyles = null;
const $cd98434c038b20e4$var$categoryList = null;
const $cd98434c038b20e4$var$categoryListItem = null;
const $cd98434c038b20e4$var$localizedLinkForCategory = (locale, categoryId)=>{
    const prefix = locale === "en" ? "" : `/${locale}`;
    if (categoryId === "recommended") return `${prefix}/software/confluence/templates`;
    return `${prefix}/software/confluence/templates/categories/${categoryId}`;
};
const $cd98434c038b20e4$export$5770244d10930a = ({ categories: categories })=>{
    const locale = (0, $3FBn4.useLocale)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _4t3i1qr7 _1bah1h6o _1o9zidpf _bfhk1rga _kqswh2mm _152tkfja _4cvresu3 _85i5zwfg _1g4s1y6m _8m2k1bp4 _9h171g80 _15951e9a _1u5xidpf _19vu1y6m _55br1bp4 _dype1g80 _1vkh1e9a _l549idpf _ag851y6m _1gde1bp4 _navj1g80 _tnrur0r7 _xlt1idpf"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _y3gn1h6o _ect41pz4 _1wybqslr _k48p1fw0 _vwz41f4h _19pkidpf _2hwxidpf _otyridpf _18u0idpf _12l212am _j2j21h6o _1yy3idpf _1po41tcg _tkvq1ylp _tgvv1tcg _gq9a1h6o _vyruidpf _qtem1tcg _1fqp1ylp _98081tcg _xsmr1h6o _1178idpf _srwz1tcg _11cg1ylp _476d1tcg"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    ...(0, $1XyNv.ConfluenceTemplateMessages).additionalCategoriesText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc _ect41pz4 _1wybdlk8 _k48p1nn1 _1dyz1a1y _syaz1hlo _zulpvbgk _slp31hna _1bah1yb4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbycs5v _n6ov11p5 _i48j16hb _9kowftgi _1yt81qr7 _kzvi11p5 _1da716hb _kd3kftgi _bcla1qr7 _suga11p5 _19d7fsjm _131yftgi _1d4svbgk"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: categories.map((category)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_2mzuglyw _vwz41f4h"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: $cd98434c038b20e4$var$localizedLinkForCategory(locale, category.urlSlug),
                            ...(0, $5VuC0.ConfluenceTemplateAnalytics).viewTemplateCategory(category.urlSlug),
                            children: category.name
                        })
                    }, category.id))
            })
        ]
    });
};
$cd98434c038b20e4$export$5770244d10930a.displayName = "AdditionalCategoriesSection";

});


parcelRegister("kTpnZ", function(module, exports) {

$parcel$export(module.exports, "TemplateSearchResultsSection", function () { return $56741f7f2b5965c2$export$a8f9e91d316b33f6; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hOqV7 = parcelRequire("hOqV7");

var $9nZPu = parcelRequire("9nZPu");

var $ggvot = parcelRequire("ggvot");

var $lzYGO = parcelRequire("lzYGO");

var $4Rq88 = parcelRequire("4Rq88");

var $81Vcz = parcelRequire("81Vcz");

var $luoAK = parcelRequire("luoAK");

var $a8pnN = parcelRequire("a8pnN");
const $56741f7f2b5965c2$var$CATEGORY = "category";
const $56741f7f2b5965c2$var$SEARCH = "search";
const $56741f7f2b5965c2$var$RECOMMENDED = "recommended";
/**
 * Create a unique key to identify the search term.
 * This is used to force a new instance
 * of `TemplatePaginatedSearchResults`
 * when the search term changes.
 */ const $56741f7f2b5965c2$var$getSearchKey = (searchTerm)=>{
    if ((0, $lzYGO.isCategoryType)(searchTerm)) return searchTerm.id;
    if ((0, $lzYGO.isTemplateType)(searchTerm)) return searchTerm.id;
    if ((0, $lzYGO.isSearchType)(searchTerm)) return searchTerm;
    return $56741f7f2b5965c2$var$RECOMMENDED;
};
const $56741f7f2b5965c2$var$getInitialState = (searchTerm, preloadedSearchResults)=>{
    if (preloadedSearchResults != null && (0, $lzYGO.isCategoryType)(searchTerm)) return {
        type: $56741f7f2b5965c2$var$CATEGORY,
        key: $56741f7f2b5965c2$var$getSearchKey(searchTerm),
        term: searchTerm,
        hasPreloadedSearchResults: true
    };
    return {
        type: null
    };
};
const $56741f7f2b5965c2$var$getNextState = (state, searchTerm)=>{
    const newKey = $56741f7f2b5965c2$var$getSearchKey(searchTerm);
    if (state.type == null || newKey !== state?.key) {
        if ((0, $lzYGO.isCategoryType)(searchTerm)) return {
            type: $56741f7f2b5965c2$var$CATEGORY,
            key: newKey,
            term: searchTerm,
            hasPreloadedSearchResults: false
        };
        else if ((0, $lzYGO.isTemplateType)(searchTerm) || (0, $lzYGO.isSearchType)(searchTerm)) return {
            type: $56741f7f2b5965c2$var$SEARCH,
            key: newKey,
            term: searchTerm
        };
        else return {
            key: newKey,
            type: $56741f7f2b5965c2$var$RECOMMENDED
        };
    }
    return state;
};
const $56741f7f2b5965c2$export$a8f9e91d316b33f6 = ({ preloadedSearchResults: preloadedSearchResults, searchTerm: searchTerm, searchIntent: searchIntent })=>{
    const [searchTypePending, startSearchTypeTransition] = (0, $iSvIT.useTransition)();
    const locale = (0, $a8pnN.useQueryLocale)();
    const [state, setState] = (0, $iSvIT.useState)(()=>$56741f7f2b5965c2$var$getInitialState(searchTerm, preloadedSearchResults));
    const [, preloadSearchIntent] = (0, $hOqV7.useQueryLoader)((0, $4Rq88.TemplateInitialSearchResultsRelayQuery));
    const [, preloadRecommendations] = (0, $hOqV7.useQueryLoader)((0, $81Vcz.TemplateRecommendationsSearchResultsRelayQuery));
    (0, $iSvIT.useEffect)(()=>{
        if (state.type == null || $56741f7f2b5965c2$var$getSearchKey(searchTerm) !== state.key) startSearchTypeTransition(()=>{
            setState((prevState)=>$56741f7f2b5965c2$var$getNextState(prevState, searchTerm));
        });
    }, [
        searchTerm,
        state
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (searchIntent && (0, $lzYGO.isCategoryType)(searchIntent)) {
            if (searchIntent.id == (0, $luoAK.DEFAULT_CATEGORY_SLUG)) preloadRecommendations((0, $81Vcz.getTemplateRecommendationsSearchResultsQueryVars)(location));
            else preloadSearchIntent({
                searchQuery: (0, $4Rq88.parseSearchQuery)(searchIntent, {
                    withLocales: [
                        locale
                    ]
                })
            });
        }
    }, [
        locale,
        preloadRecommendations,
        preloadSearchIntent,
        searchIntent
    ]);
    return searchTypePending ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $9nZPu.SkeletonTemplateRecommendationCardGrid), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9nZPu.SkeletonTemplateRecommendationCardGrid), {}),
        children: state.type === $56741f7f2b5965c2$var$RECOMMENDED ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $81Vcz.TemplateRecommendationsSearchResults), {}) : state.type === $56741f7f2b5965c2$var$SEARCH ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $lzYGO.TemplateFuzzySearchResults), {
            searchKey: state.key,
            searchTerm: state.term
        }) : state.type === $56741f7f2b5965c2$var$CATEGORY ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $ggvot.TemplateCategorySearchResults), {
            searchKey: state.key,
            searchTerm: state.term,
            preloadedSearchResults: state.hasPreloadedSearchResults ? preloadedSearchResults : null
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $9nZPu.SkeletonTemplateRecommendationCardGrid), {})
    });
};

});
parcelRegister("ggvot", function(module, exports) {

$parcel$export(module.exports, "TemplateCategorySearchResults", function () { return $2a4b06b043a144e0$export$23b7cd6a76b2bbac; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $i9Mbw = parcelRequire("i9Mbw");

var $a8pnN = parcelRequire("a8pnN");

var $4Rq88 = parcelRequire("4Rq88");

var $lgTzp = parcelRequire("lgTzp");
const $2a4b06b043a144e0$export$23b7cd6a76b2bbac = ({ preloadedSearchResults: preloadedSearchResults, searchTerm: searchTerm, searchKey: searchKey })=>{
    const locale = (0, $a8pnN.useQueryLocale)();
    const searchQuery = (0, $iSvIT.useMemo)(()=>(0, $4Rq88.parseSearchQuery)(searchTerm, {
            withLocales: [
                locale
            ]
        }), [
        searchTerm,
        locale
    ]);
    const sortLookup = (0, $i9Mbw.CategoryTemplateOrder)[searchTerm.id] ?? "name";
    return preloadedSearchResults ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $lgTzp.TemplatePaginatedSearchResults), {
        initialSearchResults: preloadedSearchResults,
        searchQuery: searchQuery,
        sortLookup: sortLookup,
        wasPreloaded: true
    }, searchKey) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Rq88.TemplateInitialSearchResults), {
        searchKey: searchKey,
        searchQuery: searchQuery,
        sortLookup: sortLookup
    });
};

});

parcelRegister("lzYGO", function(module, exports) {

$parcel$export(module.exports, "isSearchType", function () { return $4755f5a359c5f71f$export$9cbd6fec6475fd98; });
$parcel$export(module.exports, "isTemplateType", function () { return $4755f5a359c5f71f$export$c0371641c5ed5ac2; });
$parcel$export(module.exports, "isCategoryType", function () { return $4755f5a359c5f71f$export$eb6985c830adffc2; });
$parcel$export(module.exports, "TemplateFuzzySearchResults", function () { return $4755f5a359c5f71f$export$7dd0ac5165a78454; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iooib = parcelRequire("iooib");

var $hOqV7 = parcelRequire("hOqV7");

var $i9Mbw = parcelRequire("i9Mbw");

var $a8pnN = parcelRequire("a8pnN");

var $e6mpu = parcelRequire("e6mpu");

var $4Rq88 = parcelRequire("4Rq88");
function $4755f5a359c5f71f$var$parseSearchQueryFromSuggestions(templateMatches, categoryMatches, withQuery) {
    const clauses = [];
    const templateIds = templateMatches.map((result)=>result.id).filter((id)=>typeof id === "string");
    if (templateIds.length > 0) clauses.push({
        fieldNamed: "urlSlug",
        havingValues: templateIds
    });
    const categoryIds = categoryMatches.map((result)=>result.id).filter((id)=>typeof id === "string");
    if (categoryIds.length > 0) clauses.push({
        fieldNamed: "category.urlSlug",
        havingValues: categoryIds
    });
    return {
        ...withQuery,
        where: clauses.length > 1 ? {
            or: clauses
        } : clauses[0]
    };
}
const $4755f5a359c5f71f$export$9cbd6fec6475fd98 = (searchTerm)=>{
    return typeof searchTerm === "string";
};
const $4755f5a359c5f71f$export$c0371641c5ed5ac2 = (searchTerm)=>{
    return typeof searchTerm !== "string" && searchTerm?.type === "template";
};
const $4755f5a359c5f71f$export$eb6985c830adffc2 = (searchTerm)=>{
    return typeof searchTerm !== "string" && searchTerm?.type === "category";
};
const $4755f5a359c5f71f$export$7dd0ac5165a78454 = ({ searchTerm: searchTerm, searchKey: searchKey })=>{
    const locale = (0, $a8pnN.useQueryLocale)();
    const suggestionData = (0, $hOqV7.useLazyLoadQuery)((0, $e6mpu.UseSearchSuggestionsQuery), {
        locale: locale
    });
    const fuse = (0, $iSvIT.useMemo)(()=>{
        return new (0, $iooib.default)([
            ...(0, $e6mpu.parseTemplateSearchItems)(suggestionData.templates),
            ...(0, $e6mpu.parseCategorySearchItems)(suggestionData.categories)
        ], (0, $e6mpu.FUSE_OPTIONS));
    }, [
        suggestionData
    ]);
    const [templateMatches, categoryMatches] = (0, $iSvIT.useMemo)(()=>{
        const matches = fuse.search(typeof searchTerm === "string" ? searchTerm : searchTerm.name ?? searchTerm.id).sort((a, b)=>(b.score ?? Infinity) - (a.score ?? Infinity)) // Sort by score in descending order
        .map((result)=>result.item);
        if ($4755f5a359c5f71f$export$c0371641c5ed5ac2(searchTerm)) {
            // Take the first template match and discard all other matches.
            const match = matches.find((item)=>item.type === "template" && item.id === searchTerm.id);
            if (match) return [
                [
                    match
                ],
                []
            ];
        }
        return matches.slice(0, 35) // Get the top 35 results
        .reduce((acc, result)=>{
            if (result.type === "template") acc[0].push(result);
            else if (result.type === "category") acc[1].push(result);
            return acc;
        }, [
            [],
            []
        ]);
    }, [
        fuse,
        searchTerm
    ]);
    const sortLookup = (0, $iSvIT.useMemo)(()=>{
        const lookup = {};
        let rank = 1;
        // Rank template matches before category matches.
        for (const template of templateMatches)if (template.type === "template") {
            lookup[template.id] = rank;
            rank++;
        }
        // Use hardcoded category order for ranking category matches.
        for (const category of categoryMatches)if (category.type === "category") {
            const categoryLookup = (0, $i9Mbw.CategoryTemplateOrder)[category.id];
            if (categoryLookup) {
                for(const slug in categoryLookup)// Exclude templates that are already ranked.
                if (!(slug in lookup)) {
                    lookup[slug] = rank;
                    rank++;
                }
            }
        }
        return lookup;
    }, [
        categoryMatches,
        templateMatches
    ]);
    const searchQuery = (0, $iSvIT.useMemo)(()=>{
        return $4755f5a359c5f71f$var$parseSearchQueryFromSuggestions(templateMatches, categoryMatches, {
            first: Object.keys(sortLookup).length,
            withLocales: [
                locale
            ]
        });
    }, [
        categoryMatches,
        locale,
        sortLookup,
        templateMatches
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Rq88.TemplateInitialSearchResults), {
        searchKey: searchKey,
        searchQuery: searchQuery,
        sortLookup: sortLookup
    });
};

});


parcelRegister("hbLol", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $eca5ec3e2c7d59fc$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<528645e231b67c8445768b0a9d3ec0bf>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eca5ec3e2c7d59fc$var$node = function() {
    var v0 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSearch"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "partnerTemplatesDataUrlSlugs"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchQuery"
    }, v4 = {
        "items": [
            {
                "kind": "Variable",
                "name": "withLocales.0",
                "variableName": "locale"
            }
        ],
        "kind": "ListValue",
        "name": "withLocales"
    }, v5 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 50
                        },
                        v4 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "queries"
                }
            ],
            "kind": "ObjectValue",
            "name": "search"
        }
    ], v6 = {
        "alias": "categories",
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 25
            },
            {
                "kind": "Literal",
                "name": "forContentType",
                "value": "Template"
            },
            {
                "kind": "Literal",
                "name": "forFields",
                "value": [
                    "category"
                ]
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ContentPlatformContentFacetConnection",
        "kind": "LinkedField",
        "name": "contentFacet",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformContentFacet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "context",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v7 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Literal",
                                    "name": "fieldNamed",
                                    "value": "urlSlug"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "havingValues",
                                    "variableName": "partnerTemplatesDataUrlSlugs"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "where"
                        },
                        v4 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "queries"
                }
            ],
            "kind": "ObjectValue",
            "name": "search"
        }
    ], v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "templateId",
        "storageKey": null
    }, v12 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplatesUnifiedRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v5 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templateCollections",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "collectionCardCarouselRelayFragment"
                        }
                    ],
                    "storageKey": null
                },
                v6 /*: any*/ ,
                {
                    "alias": "partnerTemplates",
                    "args": v7 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templates",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "partnerTemplateCardCarouselRelayFragment"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "condition": "isSearch",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "searchQuery",
                                                "variableName": "searchQuery"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "templatePaginatedSearchResultsRelayRefetchableFragment"
                                    }
                                ],
                                "type": "Query",
                                "abstractKey": null
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "preloadedSearchResults"
                        }
                    ]
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "confluenceTemplatesUnifiedRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v5 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templateCollections",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplateCollection",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "collectionId",
                                            "storageKey": null
                                        },
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateImageAsset",
                                            "kind": "LinkedField",
                                            "name": "collectionIcon",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "url",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateCollectionGuide",
                                            "kind": "LinkedField",
                                            "name": "howToUseThisCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformTemplateCollectionStep",
                                                    "kind": "LinkedField",
                                                    "name": "collectionSteps",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ 
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                v6 /*: any*/ ,
                {
                    "alias": "partnerTemplates",
                    "args": v7 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templates",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "oneLinerHeadline",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "condition": "isSearch",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "items": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "queries.0",
                                                    "variableName": "searchQuery"
                                                }
                                            ],
                                            "kind": "ListValue",
                                            "name": "queries"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "search"
                                }
                            ],
                            "concreteType": "ContentPlatformTemplateContentSearchConnection",
                            "kind": "LinkedField",
                            "name": "templates",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplateResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "pluginModuleKey",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "previewBlurb",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformTaxonomyTemplateType",
                                                    "kind": "LinkedField",
                                                    "name": "templateType",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "id",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "templateTypeName",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "contributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v12 /*: any*/ ,
                                                            "type": "ContentPlatformOrganization",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ContentPlatformOrganization",
                                                                    "kind": "LinkedField",
                                                                    "name": "organization",
                                                                    "plural": false,
                                                                    "selections": v12 /*: any*/ ,
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "ContentPlatformAuthor",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "hasNextPage",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "endCursor",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "e7fabbe0409d86a7c3e04d6e63107259",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplatesUnifiedRelayPageQuery",
            "operationKind": "query",
            "text": 'query confluenceTemplatesUnifiedRelayPageQuery(\n  $locale: String!\n  $partnerTemplatesDataUrlSlugs: [String!]!\n  $searchQuery: ContentPlatformContentQueryInput!\n  $isSearch: Boolean = false\n) {\n  collections: templateCollections(search: {queries: {first: 50, withLocales: [$locale]}}) {\n    ...collectionCardCarouselRelayFragment\n  }\n  categories: contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: [$locale]) {\n    edges {\n      node {\n        context\n      }\n    }\n  }\n  partnerTemplates: templates(search: {queries: {withLocales: [$locale], where: {fieldNamed: "urlSlug", havingValues: $partnerTemplatesDataUrlSlugs}}}) {\n    ...partnerTemplateCardCarouselRelayFragment\n  }\n  ...templatePaginatedSearchResultsRelayRefetchableFragment_2rw059 @skip(if: $isSearch)\n}\n\nfragment collectionCardCarouselRelayFragment on ContentPlatformTemplateCollectionContentSearchConnection {\n  edges {\n    node {\n      collectionId\n      ...collectionCardRelayFragment\n    }\n  }\n}\n\nfragment collectionCardRelayFragment on ContentPlatformTemplateCollection {\n  collectionId\n  name\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionSteps {\n      __typename\n    }\n  }\n}\n\nfragment partnerTemplateCardCarouselRelayFragment on ContentPlatformTemplateContentSearchConnection {\n  edges {\n    node {\n      templateId\n      urlSlug\n      ...partnerTemplateCardRelayFragment\n    }\n  }\n}\n\nfragment partnerTemplateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  urlSlug\n  name\n  oneLinerHeadline\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsRelayRefetchableFragment_2rw059 on Query {\n  templates(search: {queries: [$searchQuery]}) {\n    edges {\n      node {\n        templateId\n        name\n        urlSlug\n        ...templateCardRelayFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n'
        }
    };
}();
$eca5ec3e2c7d59fc$var$node.hash = "8cdd9c804945fbd78aa3c9fb81ac86b1";
var $eca5ec3e2c7d59fc$export$2e2bcd8739ae039 = $eca5ec3e2c7d59fc$var$node;

});



//# sourceMappingURL=confluence-template-category-relay-page.cc69962e.js.map
